import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { } from '../types/cashFlow'
import { CashFlowExpenseFareDetailItem, CashFlowExpenseFareItem, CashFlowExpenseFareRequest } from '../types/cashFlowExpenseFare'

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowExpenseFare: builder.query<CashFlowExpenseFareItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.id}`,
      }),
    }),
    changeCashFlowExpenseFare: builder.mutation<void, PayloadRequest & CashFlowExpenseFareItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowExpenseFare: builder.mutation<void, CashFlowExpenseFareItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare`,
        method: 'POST',
        body: data
      }),
    }),

    getCashFlowExpenseFareDetailList: builder.query<CashFlowExpenseFareDetailItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.id}/details`,
      }),
    }),
    getCashFlowExpenseFareDetail: builder.query<CashFlowExpenseFareDetailItem, CashFlowExpenseFareRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.cashFlowId}/details/${data.detailId}`,
      }),
    }),
    changeCashFlowExpenseFareDetail: builder.mutation<void, CashFlowExpenseFareDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.cashFlowId}/details/${data.detailId}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowExpenseFareDetail: builder.mutation<void, CashFlowExpenseFareDetailItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.cashFlowId}/details`,
        method: 'POST',
        body: data
      }),
    }),
    deleteCashFlowExpenseFareDetail: builder.mutation<void, CashFlowExpenseFareRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseFare/${data.cashFlowId}/details/${data.detailId}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useChangeCashFlowExpenseFareMutation,
  useCreateCashFlowExpenseFareMutation,
  useGetCashFlowExpenseFareQuery,
  useLazyGetCashFlowExpenseFareQuery,

  useGetCashFlowExpenseFareDetailListQuery,
  useGetCashFlowExpenseFareDetailQuery,
  useLazyGetCashFlowExpenseFareDetailQuery,
  useDeleteCashFlowExpenseFareDetailMutation,
  useCreateCashFlowExpenseFareDetailMutation,
  useChangeCashFlowExpenseFareDetailMutation,
} =
cashFlowSchemas
